import type { ModuleConfig, User } from '../types/config';
import { moduleCodeForScreen } from '../utils/moduleAccess';

function isPortalModule(module: ModuleConfig): boolean {
  return module.id === 'student-portal' || moduleCodeForScreen(module) === 'portal';
}

/**
 * Home screen from the modules the user's DB role grants (already filtered and
 * DB-sort-ordered). No role-name config: dashboard when granted, else the
 * portal module (student/guardian roles), else the first granted module.
 */
export function resolveHomeModule(modules: ModuleConfig[], user: User): ModuleConfig | null {
  if (!modules.length) return null;

  if (user.role === 'super_admin') {
    return modules.find((module) => module.id === 'super-admin') ?? modules[0];
  }

  return (
    modules.find((module) => module.id === 'dashboard') ??
    modules.find(isPortalModule) ??
    modules.find((module) => module.path === '/') ??
    modules[0]
  );
}
